<section style="height: auto;" translate="no">
  <nav>
    <ol class="divbusca">
      <div class="div_busca_orientacao">
        <div class="item_pesquisa">
          <div class="tdTitilo">
            <label for="posto" class="form-label">Posto:</label>
          </div>
          <div class="tdCampo">
            <app-multiple-selection-select-all [lista]="listaPostos" [width]="larguraTela/2.5" [multiplePosto]="false"
              [regiaoSelecionada]="RegiaoSelecionada" [SemOpTodos]="true"
              (infoClicada)="processarInfo($event)"></app-multiple-selection-select-all>
          </div>
        </div>
        <div class="item_pesquisa" style="margin-left: 13px;">
          <div class="form-div" style=" display: flex;  justify-content: space-around; ">
            <label for="pesquisaDataInit" class="form-label">Data:</label>
            <input type="date" style="margin-left: 13px;" class="form-control" placeholder="Data" id="pesquisaDataInit"
              name="pesquisaDataInit" [(ngModel)]="pesquisaDataInit" required>
          </div>
        </div>
        <div class="tdTitilo">
          <button class="btn btn-primary btnpesquisa" (click)="filtrarPesquisa()" id="class-button"
            [disabled]="disbledBotao" type="submit">
            <div style="display: flex;">
              <div *ngIf="disbledBotao" class="loader"></div>
              Pesquisar
            </div>
          </button>
        </div>
      </div>
    </ol>
  </nav>
</section>
<section translate="no">
  <section style="height: auto;">
    <nav>
      <ol class="cd-breadcrumb custom-separator">
        <table>
          <tbody>
            <tr>
              <td class="nomeTela">
                Relatório de Grafico de Incidência
              </td>
            </tr>
          </tbody>
        </table>
      </ol>
    </nav>
  </section>
  <div class="div_orientacao">
    @if (SemDados == true) {
    <h4 class="alerta_busca">Não exite
      dados para serem mostrados
    </h4>
    }
    @if (pesquisaDataInit == "" || pesquisaDataInit == undefined || PostosSelecionados == null ||
    PostosSelecionados.length == 0) {
    <h4 class="alerta_busca">Escolha
      @if (PostosSelecionados == null || PostosSelecionados.length == 0)
      {
      um Posto
      }
      @if ((pesquisaDataInit == "" || pesquisaDataInit == undefined) && (PostosSelecionados == null ||
      PostosSelecionados.length == 0)) {
      e
      }
      @if (pesquisaDataInit == "" || pesquisaDataInit == undefined) {
      uma Data
      }
      para realizar a pesquisa.
    </h4>
    }
    @if(!feitaPesquisa && !SemDados)
    {
    <h5 class="PostoCabecalho">{{TextoCab}}
    </h5>
    @for(item of chartsData; track chartsData; let indexp = $index){
    <div class="div_orientacao" style="display: flex; justify-content: space-around; flex-wrap: wrap;">
      <div class="graficoTamanho">
        <p-chart type="line" [data]="item" [options]="options[indexp]"></p-chart>
      </div>
    </div>
    }
    }
    <div style="height: 50px;">
    </div>
  </div>